import React, { useContext } from "react";
import { observer } from "mobx-react";

import { MyBetsBetContext } from "@state/context/my-bets/MyBetsBetContext";
import { BetOffer } from "@models/BetOffer";
import EventDataWrapper from "./EventDataWrapper";
import BetOfferItemTip from "./BetOfferItemTip";
import BetOfferItemOfferResults from "./BetOfferItemOfferResults";

export default observer(function BetOfferItem(props: { offer: BetOffer }) {
	const { isSystem: isBetSystem, totalNumberOfCombinations } =
		useContext(MyBetsBetContext);

	const isSystem = isBetSystem == null;

	const systemIdStr =
		isSystem == true && totalNumberOfCombinations > 1
			? props.offer.systemIdentifier
			: "";

	return (
		<tr className="table--bets__tr">
			<td className="table--bets__td table--bets__td--combi">
				{systemIdStr}
			</td>
			<EventDataWrapper offer={props.offer} />
			<td className="table--bets__td table--bets__td--bank">
				{props.offer.isBank === true && (
					<span className="tag tag--tny tag--success u-padd--x--nano">
						B
					</span>
				)}
			</td>
			<BetOfferItemTip offer={props.offer} />
			<td
				className={`table--bets__td table--bets__td--odds u-color--offer--${props.offer.formattedBettingOfferStatus}`}
			>
				{props.offer.value.toFixed(2)}
			</td>
			<td className="table--bets__td table--bets__td--results">
				<BetOfferItemOfferResults offer={props.offer} />
			</td>
			<td className="table--bets__td table--bets__td--icon">
				<i
					className={`u-icon u-icon--tny u-icon--offer u-icon--offer--${props.offer.formattedBettingOfferStatus}`}
				/>
			</td>
		</tr>
	);
});
